var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "trial-end-clock",
        {
          attrs: {
            title: _vm.$t.__("common.labels.account_is_now_inactive"),
            subtitles: [
              _vm.$t.__("common.labels.subscription_expired"),
              _vm.$t.__(
                "pages.errors.ErrorBasic.to_continue_renew_subscription"
              )
            ]
          }
        },
        [
          _vm.hasActiveCart
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("pages.errors.ErrorBasic.validate_offer"),
                  size: "large"
                },
                on: { click: _vm.onClickValidateCart }
              })
            : _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.contact_sales"),
                  size: "large"
                },
                on: {
                  click: function($event) {
                    return _vm.window.MySupport.getForm()
                  }
                }
              }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "typographies-paragraph-medium-semibold help-message__container"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Ou revenir sur")) +
                  "\n            "
              ),
              _c("CompassLink", {
                attrs: {
                  label: _vm.$t.__("common.labels.sellsy_short_url"),
                  size: "large",
                  link: "https://go.sellsy.com"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }